import Logout from "./Logout.tsx";

export default Logout;
